// extracted by mini-css-extract-plugin
export default {"page-max-width":"1020px","pageMaxWidth":"1020px","medium":"only screen and (min-width: 768px)","title":"_1ifKi","container":"_4zPve","content":"F7xWV","productDescription":"_2Nf-y"};